/// <reference path="../../../tools/typings/tsd.d.ts"/>
/// <reference path="../services.ts"/>

namespace DealerwareWebServices
{
    "use strict";

    export class DealerwareVehicleStatesData {

        public states: any = {

            all: ['rented', 'staged', 'in_prep', 'returned', 'maintenance',
                'in_port_or_transit', 'received_mco', 'in_pdi', 'needs_registration',
                'hard_hold', 'shuttle', 'totaled_pending_ins'
            ],
            available: ['staged', 'in_prep', 'returned'],
            rented: ['rented']
        }
    }

    getDealerwareWebServicesModule().service(
        '$dealerwareVehicleStatesData', DealerwareVehicleStatesData
    );
}